import { TrackingEventName } from 'services/tracking/constants';
import { AnalysisRequirementInput } from 'services/candidate/types';
import { AnalysisRequirementUpdateInput } from 'generated-graphql/types';

export const handleRequirementsUpdateTracking = ({
  requirementsToDelete,
  requirementsToUpdate,
  requirementsToCreate,
  track
}: {
  requirementsToDelete: string[];
  requirementsToUpdate: AnalysisRequirementUpdateInput[];
  requirementsToCreate: AnalysisRequirementInput[];
  track: (eventName: string, properties?: Record<string, any>) => void;
}) => {
  track(TrackingEventName.AnalyseEditRules, {
    requirementsDelete: !!requirementsToDelete.length,
    requirementsUpdate: !!requirementsToUpdate?.length,
    requirementsCreate: !!requirementsToCreate?.length
  });
};
